export const STOP_STATUS = {
  pending: `pending`,
  incomplete: `incomplete`,
  canceled: `canceled`,
  completed: `completed`,
};

export const STOP_TASK_STATUS = {
  pending: `pending`,
  canceled: `canceled`,
  completed: `completed`,
};
